/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateInfluencerRequestViewModel } from "../types/UpdateInfluencerRequestViewModel.ts";

export const updateInfluencerRequestViewModelSchema = z.object({
  name: z.string().describe("Nome do influenciador.").nullish(),
  email: z.string().describe("Endereço de e-mail do influenciador.").nullish(),
}) as unknown as ToZod<UpdateInfluencerRequestViewModel>;
